export default [
  {
    path: '/activity-20260308-main',
    component: () => import('./Page.vue'),
    meta: { title: '女神节', id: 22 },
  },
  {
    path: '/activity-20260308-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '女神节-规则', id: 22 },
  },
]
